import axios from 'axios';
import _ from 'lodash';
import store from '@/store';

let baseURL = process.env.VUE_APP_API_URL;
let apiStatus = {};
let loadingCount = 0;

let toggleLoading = (display, displayLoading) => {
  if (!displayLoading) return;

  if (display) {
    loadingCount++;
  } else {
    loadingCount--;
  }

  if (loadingCount > 0) {
    store.commit('loading/setDisplay', true);
  } else {
    loadingCount = 0;
    store.commit('loading/setDisplay', false);
  }
};

export default (method, url, cb, config = {}, errCb, handleResponse) => {
  let isStillGetting = _.get(apiStatus, url, false);

  if (!isStillGetting) {
    if (!config.skipSetApiStatus) {
      _.set(apiStatus, url, true);
    }

    let defaultConfig = {
      baseURL,
      method,
      url,
      displayLoading: true
    };

    let usingConfig = Object.assign(defaultConfig, config);

    toggleLoading(true, usingConfig.displayLoading);

    axios(usingConfig)
      .then(response => {
        handleResponse(response, cb, errCb);

        _.unset(apiStatus, url);

        toggleLoading(false, usingConfig.displayLoading);
      })
      .catch(error => {
        _.unset(apiStatus, url);
        toggleLoading(false, usingConfig.displayLoading);

        let status = error.response.status;

        if (status == 401) {
          store.commit('user/setUser', {});
          store.commit('user/setShowModal', true);
        } else {
          alert('伺服器連線異常');
        }
      });
  }
};
